/**
 * Сервис для работы с уведомлениями
 */

import axios from 'axios';

import { IId } from '../models/types';
import getFormData from '../utils/getFormData';
import { pageSize } from '../constants/pagination';

export interface IGetAllParams {
  notificationType: string;
  notificationTarget: string;
  employeesList: string | undefined;
  from: string;
  to: string;
  pageIndex: number;
}

export interface IBody {
  text: string;
  employeesList: IId[];
}

export interface IUpdateOrCreateTemplate {
  id: IId;
  notificationClass: string;
  name: string;
  target: string;
  channelType: string;
  template: string;
  employeesList: IId[];
  isNeedConfirmation: boolean;
  isNeedSound: boolean;
  isNeedVibro: boolean;
}

export type ITemplateBody = IUpdateOrCreateTemplate;

export interface IParams {
  areaId?: IId;
  employeesList?: IId;
  needConfirmRead?: boolean;
  hasPlatformText?: boolean;
  notificationTarget?: string;
  pageIndex?: number;
  pageSize?: number;
}

export interface IParamsTemplate {
  areaId?: IId;
  employeesList?: IId;
  needConfirmRead?: boolean;
  notificationTarget?: string;
  pageIndex?: number;
  pageSize?: number;
}

export interface IGetTemplateAllParams {
  notificationType: string;
  notificationTarget: string;
  employeesList: string;
  pageIndex: number;
}

export interface IConfirmNewBody {
  uid: IId;
  type: string;
  text: string;
  isSuccessfull: boolean;
  time: string;
  userId: IId;
  userDevice: string;
  senderAddress: string;
  senderMessageId: string;
  senderMessage: string;
  retryCount: number;
}

export interface IGetOperatorMessagesParams {
  Limit?: number;
  From?: string;
  To?: string;
  Class?: string;
  MessageSeverity?: string;
  MapId?: string;
  AreaId?: string;
  UserId?: string;
}

const url = '/notification';

const NotificationsService = {
  getAll: (params: IGetAllParams) =>
    axios.get(`${url}/events`, { params: { pageSize, hasPlatformText: true, ...params } }),
  getFullAll: (params: IParams = {}) => axios.get(`${url}/events`, { params }),
  getTypesAll: () => axios.get(`${url}/types`),
  getVariablesAll: () => axios.get(`${url}/variables`),
  getTargetsAll: () => axios.get(`${url}/targets`),
  getTemplatesAll: (params: IParamsTemplate = {}) => axios.get(`${url}/templates`, { params }),
  getTemplateAll: (params: IGetTemplateAllParams) =>
    axios.get(`${url}/templates`, { params: { pageSize, ...params } }),
  getTemplate: (id: IId) => axios.get(`${url}/template?id=${id}`),
  send: (body: IBody) => axios.post(`${url}/informational`, getFormData(body)),
  postpone: (id: IId, seconds: number) =>
    axios.post(`${url}/postpone?id=${id}&seconds=${seconds}`),
  confirm: (body: IConfirmNewBody) => axios.post(`${url}/confirm`, body),
  updateOrCreateTemplate: (body: IUpdateOrCreateTemplate) => axios.post(`${url}/template`, body),
  deleteTemplate: (id: IId) => axios.delete(`${url}/template?id=${id}`),
  getUnreadForOperator: (params: IGetOperatorMessagesParams = { Limit: 100 }) =>
    axios.get(`${url}/message/forOperator`, { params })
};

export default NotificationsService;
